import type Shipment from 'interfaces/PmParcel';
import {
  ItemProgress,
  ItemNumber,
  ItemLabel,
  IconContainer,
  ItemNumberWrapper,
  ItemLabelType,
  ItemContainer,
} from './Item.styles';
import type { ShipmentProgress } from '../../models';

export interface ItemProps extends ShipmentProgress {
  baseShipment: Shipment;
  numberOfShipment?: number;
  isActiveShipment?: boolean;
  isDropdownItem?: boolean;
  index?: number;
  label?: string;
  onSelectShipment?: (selectedShipment: Shipment) => void;
  formatShipmentHeadingLabel: (shipment: Shipment) => string;
}

const Item: React.FC<ItemProps> = (props) => {
  const {
    activeStage,
    iconTheme,
    baseShipment: currentShipment,
    numberOfShipment = 0,
    isActiveShipment = false,
    index = 0,
    isDropdownItem = false,
    label: itemTypeLabel,
    onSelectShipment,
    formatShipmentHeadingLabel,
  } = props;

  const { label, icon: Icon } = activeStage;
  const { iconBgColor, iconColor, labelFontSize } = iconTheme;
  const isLastItem = numberOfShipment === index + 1;

  const getHTMLDisplay = () => {
    return onSelectShipment ? 'button' : 'div';
  };

  return (
    <ItemContainer
      isActive={isActiveShipment}
      isDropdownItem={isDropdownItem}
      isLastItem={isLastItem}
      isClickable={!!onSelectShipment}
      onClick={() => onSelectShipment?.(currentShipment)}
      as={getHTMLDisplay()}
    >
      {Icon && (
        <IconContainer>
          <Icon
            bgColor={iconBgColor}
            color={iconColor}
            width={24}
            height={24}
          />
        </IconContainer>
      )}

      <ItemProgress>
        <ItemNumberWrapper>
          <ItemNumber
            isActive={isActiveShipment}
            isDropdownItem={isDropdownItem}
          >
            {formatShipmentHeadingLabel(currentShipment)}
          </ItemNumber>
          {itemTypeLabel && <ItemLabelType>{itemTypeLabel}</ItemLabelType>}
        </ItemNumberWrapper>

        <ItemLabel
          labelFontSize={labelFontSize}
          isActive={isActiveShipment}
          isDropdownItem={isDropdownItem}
        >
          {label}
        </ItemLabel>
      </ItemProgress>
    </ItemContainer>
  );
};

export default Item;
